import React from 'react';
import Button, {ButtonColor, ButtonVariant} from "./components/Button";
import Input from "./components/Input";
import FlexContainer from "./components/FlexContainer";
import TitleHeading from "./components/TitleHeading";
import Navbar from "./components/Navbar";
import Container from "./components/Container";
import styled from "styled-components";
import MainPage from "./pages/MainPage";

export const AppContainer = styled(Container)`
  background: var(--background-dark-100);
  border-radius: 10px;
  padding: 50px;

`

function App() {

  return (
    <div className="App">
        <Navbar />
        <FlexContainer>
            <AppContainer maxWidth={"1000px"}>
                <MainPage />
            </AppContainer>
        </FlexContainer>
    </div>
  );
}

export default App;
